import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DurchfuehrungsTag, Product } from './Product.js';

/**
 * @entity ProductLUS
 */
@Entity()
export class ProductLUS extends Product {
  public static override _class = 'ProductLUS';

  @Field(() => String)
  public location: Maybe<string>;

  @Field(() => [DurchfuehrungsTag], { default: v => v ?? [] })
  public durchfuehrungsTage: Maybe<DurchfuehrungsTag[]>;

  @Field(() => Int)
  public proWoche: Maybe<number>;

  @Field(() => Int)
  public dauer: Maybe<number>;

  @Field(() => Int)
  public US: Maybe<number>;
}
